import React from "react";
import {Navbar,Footer} from '../hrcomponents';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { monthList } from '../utils/datalist';
import { Tabs, Tab ,Image} from 'react-bootstrap';
import { empCategory, empType, empGrade, bloogGroup } from '../utils/datalist';
import districts from "../utils/bd-districts.json";
import postcodes from "../utils/bd-postcodes.json";
import Select from "react-select";

const EmployeeEdit=()=>{

    if(localStorage.getItem('branchID')===null){
        window.location.replace('/hris');
    }

    const { id } = useParams();

    const [empData,setEmpData]=useState([]);
    const [deptList,setDeptList]=useState([]);
    const [desigtList,setDesigtList]=useState([]);
    const [searchCode,setSearchCode]=useState('');
    const [noResults, setNoResults] = useState(false);

    useEffect(() => {
        const getEmpData = async () => {
            const response=await axios.get(configData.SERVER_URL+`/empDataByID/${id}`);
            setEmpData(response.data[0]);

            const deptRes=await axios.get(configData.SERVER_URL+`/deptData/${localStorage.getItem('branchID')}`);
            setDeptList(deptRes.data); 
            
            const desigRes=await axios.get(configData.SERVER_URL+`/designations`);
            setDesigtList(desigRes.data);
        };
        getEmpData();
  
    }, []);

    const handleInput=(e)=>{
        const {name,value}=e.target; 
        setEmpData({...empData,[name]:value});  
    }

    const handleSelectChange = (selectedOption, fieldName) => {
        setEmpData({
            ...empData,
            [fieldName]: selectedOption.value
        });
    };

    const handleSelectCustomData = (selectedOption, valueName, labelName) => {
        setEmpData(prev => ({...prev,
            ...(valueName && {
            [valueName]: selectedOption.value
            }),
            ...(labelName && {
            [labelName]: selectedOption.label
            })
        }))
    };


    const handleSubmit=async(e)=>{
        e.preventDefault();
       
        try {
            let res=await axios.post(configData.SERVER_URL+`/empDataEdit/${empData.id}`,empData);
            if(res.status===200){
                alert('Successfully Updated');
            } 
            else{
                alert('System Error');
            } 
        } catch (error) {
            console.error('System error:', error);
        }   
    }

    const handleSubmitAddress=async(e)=>{
        e.preventDefault();
        
        try {
            let res=await axios.post(configData.SERVER_URL+`/empDataEditAddress/${empData.id}`,empData);
            if(res.status===200){
                alert('Address Successfully Updated');
            } 
            else{
                alert('System Error');
            } 
        } catch (error) {
            console.error('System error:', error);
        }  
    }

    const handleKeyDown = async(e) => {
    if (e.key === 'Enter') {
        var searchCode=document.getElementById('empCode').value;
        const response=await axios.get(configData.SERVER_URL+`/empDataByCode/${searchCode}`);
        if (!response.data[0]) {
            setNoResults(true);
            return
        } else {
            setEmpData(response.data[0]);
            setNoResults(false);
        }
    }
    };

    const deptOptions = deptList.map(d => ({
    value: String(d.id),
    label: `${d.deptName}`
    }));

    const desigOptions = desigtList.map(d => ({
    value: String(d.id),
    label: `${d.desigName}`
    }));

    const districtOptions = districts.districts.map(d => ({
    value: String(d.id),
    label: `${d.name}`
    }));

    const postcodeOptions = postcodes.postcodes.map(d => ({
    value: String(d.postCode),
    label: `${d.postCode}/${d.postOffice}`
    }));

    return(
        <>
        <div className='container'>

            <div className="card shadow border-0" 
                style={{ background: "#fff", borderRadius: "18px", overflow: "hidden", }}>
            {/* Header */}
            <div className="card-header d-flex justify-content-between align-items-center"
                style={{
                background: "linear-gradient(135deg, #0dcaf0, #0d6efd)",
                color: "#fff",
                padding: "18px 25px",
                border: "none",
                }} >
                <div>
                    <h3 className="mb-0 fw-bold">Employee Info Edit</h3>
                    <small>Edit Employee Personal/Official Data</small>
                </div>
            </div>

            <div className="card-body" style={{backgroundColor: "lightgrey", padding: "20px", borderRadius: "10px"}}>
            
                <div className="row well">                    
                    <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <label>Emp Code</label>
                        <input type="text" className="form-control" name="empCode" id="empCode" value={empData.empCode} onChange={(e)=>{handleInput(e)}} onKeyDown={handleKeyDown}></input>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label>Fingerprint/Face ID</label>
                            <input type="text" className="form-control" id="fp_code" name="fp_code" value={empData.fp_code} readOnly></input>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                        <label>Employee Name</label>
                        <input type="text" className="form-control" name="empName" id="empName" value={empData.empName} readOnly ></input>
                    </div>
                </div>
           
                <hr></hr>
                {noResults && <p class="text-center" style={{color:'red'}} >No results found.</p>}
                
                {/* <div className="row well" style={{backgroundColor: "lightgrey", padding: "20px", borderRadius: "10px"}}>
                <Tabs defaultActiveKey="photopraphy" id="react-bootstrap-tabs" className="mb-3" style={{backgroundColor:'lightskyblue'}} >
                    <Tab eventKey="photopraphy" title="Personal Photo Upload">
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <Image src="http://localhost:3000/img/noimage.png" width={150} height={150} rounded></Image> 
                        </div>
                    </Tab>
                </Tabs>
                </div> */}

                
                <div className="card border-info" style={{ padding: "10px", borderRadius: "10px"}}>
                <div className="card-body">
                <Tabs defaultActiveKey="official" id="react-bootstrap-tabs" className="mb-3" style={{backgroundColor:'lightskyblue'}} >
                    <Tab eventKey="official" title="Official Information">
                        <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">
                            <label>Employee Status</label>
                            <select className="form-select" id="empStatus" name="empStatus" value={empData.empStatus} onChange={(e)=>{handleInput(e)}}>
                            <option value=''>---</option>
                            <option value='A'>Active</option>
                            <option value='I'>In-Active</option>
                            </select>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">
                            <label>Employee Category</label>
                            <select className="form-select" id="empCategory" name="empCategory" value={empData.empCategory} onChange={(e)=>{handleInput(e)}}>
                            <option value=''>---</option>
                            {empCategory.map(category => (
                            <option key={category.code} value={category.code}>{category.name}</option>
                            ))}
                            </select>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">
                            <label>Employee Type</label>                           
                            <select className="form-select" id="empType" name="empType" value={empData.empType} onChange={(e)=>{handleInput(e)}}>
                            <option value=''>---</option>
                            {empType.map(eType => (
                            <option key={eType.code} value={eType.code}>{eType.name}</option>
                            ))}
                            </select>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">
                            <label>Employee Grade</label>
                            <select className="form-select" id="grade" name="grade" value={empData.grade} onChange={(e)=>{handleInput(e)}}>
                            <option value='0'>---</option>
                            {empGrade.map(empgrade => (
                            <option key={empgrade.id} value={empgrade.id}>{empgrade.name}</option>
                            ))}
                            </select>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <label>Date of Join </label>
                            <input type="date" className="form-control" id="dateOfJoin" name="dateOfJoin" value={empData.dateOfJoin} onChange={(e)=>{handleInput(e)}}></input>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <label>Department</label>
                            <Select
                            options={deptOptions} isSearchable  
                            placeholder="Select Department..."
                            value={deptOptions.find(option => String(option.value) === String(empData.deptID))}
                            onChange={(option) =>handleSelectChange(option, "deptID")}
                            />
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <label>Designation</label>
                            <Select
                            options={desigOptions} isSearchable  
                            placeholder="Select Desigantion..."
                            value={desigOptions.find(option => String(option.value) === String(empData.desigID))}
                            onChange={(option) =>handleSelectChange(option, "desigID")}
                            />
                        </div>
                    </Tab>

                    <Tab eventKey="personal" title="Personal Information">
                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label>National ID</label>
                            <input type="text" className="form-control" id="NID" name="NID" value={empData.NID} onChange={(e)=>{handleInput(e)}}></input>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label>Blood Group</label>
                            <select className="form-select" id="bloodGroup" name="bloodGroup" value={empData.bloodGroup} onChange={(e)=>{handleInput(e)}}>
                            <option value=''>---</option>
                            {bloogGroup.map(bGroup => (
                            <option key={bGroup.code} value={bGroup.code}>{bGroup.name}</option>
                            ))}
                            </select>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <label>Date of Birth</label>
                            <input type="date" className="form-control" id="dateOfBirth" name="dateOfBirth" value={empData.dateOfBirth} onChange={(e)=>{handleInput(e)}}></input>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">
                            <label>Marital Status</label>
                            <select className="form-select" id="marritalStatus" name="marritalStatus" value={empData.marritalStatus} onChange={(e)=>{handleInput(e)}}>
                            <option value=''>---</option>
                            <option value='Married'>Married</option>
                            <option value='UnMarried'>Un-Married</option>
                            </select>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-8 col-xs-12">
                            <label>Spouse Name</label>
                            <input type="text" className="form-control" id="spouseName" name="spouseName" value={empData.spouseName} onChange={(e)=>{handleInput(e)}}></input>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-8 col-xs-12">
                            <label>Spouse Qualification</label>
                            <input type="text" className="form-control" id="spouseQualification" name="spouseQualification" value={empData.spouseQualification} onChange={(e)=>{handleInput(e)}}></input>
                        </div>

                        <div className="col-lg-2 col-md-2 col-sm-3 col-xs-4">
                            <label>No. of Chield</label>
                            <input type="number" className="form-control" id="noOfChield" name="noOfChield" value={empData.noOfChield} onChange={(e)=>{handleInput(e)}}></input>
                        </div>
                    </Tab>                   
                </Tabs>
                </div>
                <div className="card-footer">
                    {!noResults &&
                    <button type="button" class="btn btn-primary" style={{borderRadius:'30px'}}>
                    <span onClick={(e)=>{handleSubmit(e)}}>Post Official/Personal Info</span>              
                    </button>
                    }
                </div>
                </div>

                <hr></hr>

                <div className="card border-info" style={{padding: "10px", borderRadius: "10px"}}>
                <div className="card-body">
                <Tabs defaultActiveKey="address" id="react-bootstrap-tabs" className="mb-3" style={{backgroundColor:'lightskyblue'}}>
                    <Tab eventKey="address" title="Address Details">
                        <div className="card my-3 ">
                            <div className="card-header"><h8 className="mb-0" style={{color:'green'}}>Present Address</h8></div>
                            <div className="card-body">
                                <div className="row ">
                                    <div className="col-md-12 ">Address
                                        <input type="text" className="form-control" id="pre_address" name="pre_address" value={empData.pre_address} onChange={(e)=>{handleInput(e)}}></input>
                                    </div>
                                </div>
                                <div className="row ">
                                    <div className="col-md-4 ">District                                                           
                                    <Select
                                        options={districtOptions} isSearchable  
                                        placeholder="Select District..."
                                        value={districtOptions.find(option => String(option.label) === String(empData.pre_district))}
                                        onChange={(option) =>handleSelectCustomData(option, "", "pre_district")}
                                    />
                                    </div>

                                    <div className="col-md-4 ">Post Code                     
                                    <Select
                                        options={postcodeOptions} isSearchable  
                                        placeholder="Select Post-Code..."
                                        value={postcodeOptions.find(option => String(option.value) === String(empData.pre_postcode))}
                                        onChange={(option) =>handleSelectCustomData(option, "pre_postcode","pre_postoffice")}
                                    />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card my-3">
                            <div className="card-header"><h8 className="mb-0" style={{color:'green'}}>Permanent Address</h8></div>
                            <div className="card-body">
                                <div className="row ">
                                    <div className="col-md-12 ">Address
                                        <input type="text" className="form-control" id="per_address" name="per_address" value={empData.per_address} onChange={(e)=>{handleInput(e)}}></input>
                                    </div>
                                </div>
                                <div className="row ">
                                    <div className="col-md-4 ">District                                                           
                                    <Select
                                        options={districtOptions} isSearchable  
                                        placeholder="Select District..."
                                        value={districtOptions.find(option => String(option.label) === String(empData.per_district))}
                                        onChange={(option) =>handleSelectCustomData(option,"", "per_district")}
                                    />
                                    
                                    </div>

                                    <div className="col-md-4 ">Post Code                     
                                    <Select
                                        options={postcodeOptions} isSearchable  
                                        placeholder="Select Post-Code..."
                                        value={postcodeOptions.find(option => String(option.value) === String(empData.per_postcode))}
                                        onChange={(option) =>handleSelectCustomData(option, "per_postcode","per_postoffice")}
                                    />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                    
                </Tabs>
                </div>
                <div className="card-footer">
                    {!noResults &&
                    <button type="button" class="btn btn-primary" style={{borderRadius:'30px'}}>
                    <span onClick={(e)=>{handleSubmitAddress(e)}}>Post Address</span>              
                    </button>
                    }               
                </div>
                </div>

                {/* <hr></hr>
                <div className="row well" style={{backgroundColor: "lightgrey", padding: "20px", borderRadius: "10px"}}>
                    <Tabs defaultActiveKey="education" id="react-bootstrap-tabs" className="mb-3" style={{backgroundColor:'lightskyblue'}} >
                        <Tab eventKey="education" title="Educational Information">
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <table className="table table-hover">
                                <thead>
                                    <th>Degree</th>
                                    <th>Institution</th>
                                    <th>Result</th>
                                    <th>Passing Year</th>
                                </thead>
                            </table>
                        </div>
                    </Tab>
                    </Tabs>
                </div>               */}
                
            </div>
        </div>

        </div>
        
        </>
    )

}

export default EmployeeEdit;